// Browser authentication stays in an HttpOnly cookie. Android tokens use the
// SessionVault plugin (Android Keystore), never localStorage or a hardware ID.
import { registerPlugin } from '@capacitor/core';
import { storage } from './storage.js';

const vault = registerPlugin('SessionVault');
let current = null;
const native = () => Boolean(globalThis.window?.Capacitor?.isNativePlatform?.());

export function serverIdentity(settings) {
  return String(settings.baseUrl || globalThis.window?.location?.origin || '').replace(/\/+$/, '');
}

export function sessionHeaders(origin) {
  if (!current || current.origin !== origin) return {};
  return { ...(current.token ? { Authorization: `Bearer ${current.token}` } : {}),
    ...(current.csrf ? { 'X-CSRF-Token': current.csrf } : {}) };
}

export function canActAs(player, origin) {
  return !current || current.origin !== origin || player === current.me?.player?.id;
}

export function recordingOwnerConflict(me, recording, previousPlayer) {
  return Boolean(recording?.active && (recording.active.player || previousPlayer || 'me') !== me?.player?.id);
}

export async function loadAccountSession(origin) {
  const saved = storage.get('accountSession', null);
  current = saved?.origin === origin ? { ...saved, token: null } : null;
  if (native()) {
    const { value } = await vault.get();
    if (value) {
      try { const secure = JSON.parse(value); if (secure.origin === origin) current = { ...current, ...secure }; } catch { /* invalid vault: normal login */ }
    }
  }
  return current?.me || null;
}

export async function saveAccountSession(me, origin) {
  const next = { origin, csrf: me.csrf, me: { account: me.account, player: me.player,
    membership: me.membership, expires_at: me.expires_at }, token: me.session_token || (current?.origin === origin ? current.token : null) };
  if (native() && next.token) await vault.set({ value: JSON.stringify({ origin, token: next.token }) });
  // Contains display data and a CSRF nonce, but no login or recovery secret.
  storage.set('accountSession', { origin, csrf: next.csrf, me: next.me });
  current = next;
  storage.set('player', me.player.id);
  return next.me;
}

export async function clearAccountSession() {
  if (native()) await vault.clear();
  current = null;
  storage.remove('accountSession');
  storage.remove('player');
}

export function validOfflineAccount(me, now = Date.now() / 1000) {
  return Boolean(me?.account?.id && me?.player?.id && me.expires_at > now);
}
